/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum EventType {
    Simulation = 0,
    Exam = 1,
    PeerPractice = 2,
    MultiRoomRecording = 3,
    AutomaticRecording = 4,
}
